/**
 * Navigation bar component for the dashboard.
 */

import BugReportModal from '@/components/modals/BugReportModal';
import LogoutModal from '@/components/modals/LogoutModal';
import LanguageSwitcher from '@/components/dashboard/LanguageSwitcher';
import { useAuth } from '@/contexts/AuthContext';
import { isAdminUser } from '@/utils/admin';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export default function DashboardNavbar() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [showBugReport, setShowBugReport] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const isAdmin = isAdminUser(user);

  return (
    <>
      <Navbar expand="lg" className="mb-4">
        <Container>
          <LinkContainer to="/home">
            <Navbar.Brand style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
              <img
                src="/myant-logo.png"
                alt="Myant Logo"
                style={{
                  height: '32px',
                  width: 'auto',
                }}
                onError={(e) => {
                  // Fallback: hide image if it fails to load
                  e.currentTarget.style.display = 'none';
                }}
              />
              <span style={{ fontWeight: 600, fontSize: '1.25rem', color: 'var(--myant-text-primary)' }}>
                {t('navbar.dataShop')}
              </span>
              <span
                style={{
                  fontSize: '0.875rem',
                  color: 'var(--myant-text-secondary)',
                  fontWeight: 400,
                  marginLeft: '0.25rem',
                }}
              >
                {t('navbar.byMyant')}
              </span>
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <LinkContainer to="/datasets">
                <Nav.Link>
                  {t('common.datasets')}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to="/orders">
                <Nav.Link>
                  {t('common.orders')}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to="/access-request">
                <Nav.Link>
                  <i className="fas fa-key me-1"></i>
                  {t('common.accessRequest')}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to="/profile">
                <Nav.Link>
                  {t('common.profile')}
                </Nav.Link>
              </LinkContainer>
              {isAdmin && (
                <LinkContainer to="/admin">
                  <Nav.Link
                    style={{
                      color: '#001f3f',
                      fontWeight: 600,
                    }}
                  >
                    {t('common.admin')}
                  </Nav.Link>
                </LinkContainer>
              )}
              <Nav.Link
                onClick={() => setShowBugReport(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#ff6b6b',
                  fontWeight: 500,
                }}
              >
                <i className="fas fa-bug"></i>
                {t('navbar.bugReport')}
              </Nav.Link>
              <LanguageSwitcher />
              <NavDropdown title={user?.email || t('navbar.user')} id="user-dropdown">
                <NavDropdown.Item onClick={() => setShowLogout(true)}>{t('common.logout')}</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <BugReportModal show={showBugReport} onHide={() => setShowBugReport(false)} />
      <LogoutModal show={showLogout} onHide={() => setShowLogout(false)} />
    </>
  );
}
